import { useState, useEffect } from 'react';

export const useOnMount = (fn: () => void): void => {
  const [isMounted, setIsMounted] = useState<boolean>(false);

  useEffect(() => {
    if (isMounted) {
      return;
    }
    fn();
    setIsMounted(true);
  }, []);
};
